/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalMCPTaskRecord } from './InternalMCPTaskRecord';
import {
    InternalMCPTaskRecordFromJSON,
    InternalMCPTaskRecordFromJSONTyped,
    InternalMCPTaskRecordToJSON,
    InternalMCPTaskRecordToJSONTyped,
} from './InternalMCPTaskRecord';

/**
 * 
 * @export
 * @interface InternalMCPTaskResponse
 */
export interface InternalMCPTaskResponse {
    /**
     * 
     * @type {InternalMCPTaskRecord}
     * @memberof InternalMCPTaskResponse
     */
    task: InternalMCPTaskRecord;
}

/**
 * Check if a given object implements the InternalMCPTaskResponse interface.
 */
export function instanceOfInternalMCPTaskResponse(value: object): value is InternalMCPTaskResponse {
    if (!('task' in value) || value['task'] === undefined) return false;
    return true;
}

export function InternalMCPTaskResponseFromJSON(json: any): InternalMCPTaskResponse {
    return InternalMCPTaskResponseFromJSONTyped(json, false);
}

export function InternalMCPTaskResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalMCPTaskResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'task': InternalMCPTaskRecordFromJSON(json['task']),
    };
}

export function InternalMCPTaskResponseToJSON(json: any): InternalMCPTaskResponse {
    return InternalMCPTaskResponseToJSONTyped(json, false);
}

export function InternalMCPTaskResponseToJSONTyped(value?: InternalMCPTaskResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'task': InternalMCPTaskRecordToJSON(value['task']),
    };
}

